import $ from "cash-dom";
import {standardCalculatorComponent} from "./calculator/standard";

$(document).ready(() => {
    standardCalculatorComponent('form');
});
